import React from "react";
import classnames from "classnames";
import { Icon } from "../components";

interface CheckboxProps {
  testID?: string;
  value?: boolean;
  disabled?: boolean;
  onChange?: (value: boolean) => void;
}

export function Checkbox(props: CheckboxProps) {
  const { testID, value, onChange = () => {}, disabled } = props;
  const [focused, setFocused] = React.useState(false);

  return (
    <div
      className={classnames(
        "checkbox-root",
        value ? "checkbox-root-checked" : "checkbox-root-unchecked",
        focused && "checkbox-focused",
        disabled && "checkbox-disabled"
      )}
    >
      <input
        className="checkbox-input"
        data-testid={testID}
        type="checkbox"
        checked={value}
        onChange={() => onChange(!value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      {value && (
        <div className="checkbox-checkmark">
          <Icon name="check" color="white" size={16} />
        </div>
      )}
    </div>
  );
}
